import * as React from 'react';
import { Component } from 'react';
import { debounce } from 'lodash';

import { formatDollars, isValidNumber } from '../../utils/formatUtils';
import ToolTipIconUI from '../ToolTipIcon/ToolTipIconUI';

export interface ICurrencyInputUIProps {
    analyticsId?: string;
    id?: string;
    label?: string;
    onBlur?: any;
    onBlurValidation?: any;
    onImmediateUpdateValue?: any;
    onUpdateValue?: any;
    currencyValue?: any;
    isReadOnly?: boolean;
    placeHolder?: string;
    disableOnReadOnly?: boolean;
    showAlert?: boolean;
    forceCursorToEnd?: boolean;
    onAlertClick?: { () };
}

export interface ICurrencyInputUIState {
    currencyValue?: number;
    displayError?: any;
}

class CurrencyInputUI extends Component<ICurrencyInputUIProps, ICurrencyInputUIState> {
    debouncedUpdateValue: (() => void);
    constructor(props) {
        super(props);
        this.state = {
            currencyValue: props.currencyValue,
            displayError: false
        };
        this.debouncedUpdateValue = debounce(() => { this.props.onUpdateValue(this.state.currencyValue); }, 2000);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.currencyValue !== this.state.currencyValue) {
            this.setState({ currencyValue: nextProps.currencyValue });
        }
    }
    immediateUpdateValue(value) {
        if (this.props.onImmediateUpdateValue) {
            this.props.onImmediateUpdateValue(value);
        }
    }
    onChange(event) {
        this.setState({ displayError: false });
        let value = event.target.value;
        value = value.replace('$', '').replace(/,/g, '');
        if (isValidNumber(value)) {
            value = Number(value);
            this.setState({ currencyValue: value });
            this.immediateUpdateValue(value); // to update state tree immediately
            this.debouncedUpdateValue(); // to defer API call until we think user has finished typing
        }
    }

    onBlur(event) {
        let isValidValue = true;
        if (this.props.onBlurValidation) {
            isValidValue = this.props.onBlurValidation(this.state.currencyValue);
        }
        if (isValidValue) {
            this.setState({ displayError: false });
        } else {
            this.setState({ displayError: true });
        }

        if (this.props.onBlur) {
            this.props.onBlur(event.target.value);
        }
    }

    onFocus(event) {
        if (this.props.forceCursorToEnd) {
            const length = event.target.value.length;
            const inputTarget = event.target;
            if (length > 0) {
                setTimeout(() => {
                    inputTarget.setSelectionRange(length, length);
                },         0);
            }
        }
    }

    render() {

        const { label, placeHolder, onAlertClick, id, analyticsId, showAlert, isReadOnly } = this.props;

        const labelDiv = (
            <div className="currency-input__label control-label inline-label input-label">
                {label}
            </div>
        );
        let placeholderText = placeHolder;
        if (this.state.displayError) {
            placeholderText = placeHolder ? placeholderText : 'Enter a valid value';
        }
        const alertComponent = (
            <div className="info-icon">
                <ToolTipIconUI
                    iconClass="info-circle"
                    onClick={onAlertClick}
                />
            </div>
        );
        let inputClasses = 'form-control';
        inputClasses = showAlert ? `${inputClasses} show-alert` : inputClasses;
        inputClasses = isReadOnly ? `${inputClasses} currency-input--read-only` : inputClasses;
        const dollarValue = formatDollars(this.state.currencyValue);

        return (
            <div className="currency-input">
                <div className="input-group">
                    { label ? labelDiv : null }
                    <input
                        className={inputClasses}
                        id={id}
                        pattern="[0-9]*"
                        data-analytics={analyticsId}
                        type="tel"
                        inputMode="numeric"
                        placeholder={placeHolder}
                        value={dollarValue}
                        onChange={(event) => { this.onChange(event); }}
                        onBlur={(event) => { this.onBlur(event); }}
                    />
                    { showAlert ? alertComponent : null }
                </div>
            </div>
        );
    }


}

export default CurrencyInputUI;
